<template>
    <new-select-option
        autosubmit
        name="formation"
        prefix="Formation:"
        :model-value="props.value ? props.value : ''"
        @update:modelValue="handleValueUpdate"
        :options="list"
    ></new-select-option>
</template>
<script setup>
import { computed, defineProps, reactive, onMounted, defineEmits } from "vue";
import emitter from "tiny-emitter/instance";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
    teamId: {
        type: Number,
    },
    value: {
        type: String,
    },
    formations: {
        type: Array,
    },
});
const state = reactive({
    formations: props.formations,
});

const list = computed(() => {
    const source = state.formations;
    let data = [
        {
            label: "",
            value: "",
        },
    ];
    if (source?.length) {
        data = [
            ...data,
            ...source.map((formation) => ({
                label: formation.name,
                value: formation.id,
            })),
        ];
    }

    return data;
});

emitter.on("formation-updated", (data) => {
    state.formations = data;
});

function handleValueUpdate(value) {
    emit("update:modelValue", value);
}

async function getData() {
    const teamId = props.teamId ? props.teamId : "";
    state.formations = (await axios.get(`/formation?team_id=${teamId}`)).data;
    return state.formations;
}
</script>
